import React, { FunctionComponent, useRef } from 'react';

import * as Sentry from '@sentry/react';
import Box from '@material-ui/core/Box';

import { QuoteSection } from './components/Section';

import SectionAbout from './SectionAbout';
import SectionAboveTheFold from './SectionAboveTheFold';
import SectionFeatures from './SectionFeatures';
import SectionFeedback from './SectionFeedback';
import SectionContact from './SectionContact';
import SectionFooter from './SectionFooter';
import SectionHeader from './SectionHeader';

const SectionFeaturesFallbackComponent: FunctionComponent = () => {
  return (
    <Box textAlign="center" py={10}>
      error
    </Box>
  );
};

const Home: FunctionComponent = () => {
  const aboutRef = useRef(null);
  const featuresRef = useRef();
  const feedbackRef = useRef(null);
  const appRef = useRef(null);

  return (
    <>
      <SectionHeader
        aboutRef={aboutRef}
        featuresRef={featuresRef}
        feedbackRef={feedbackRef}
        appRef={appRef}
      />
      <SectionAboveTheFold />
      <SectionAbout sectionRef={aboutRef} />
      <QuoteSection
        href="...."
        title="On average, music preferences are the first topic of conversation amongst strangers"
        subtitle="The role of music preferences in interpersonal perception"
      />
      <Sentry.ErrorBoundary fallback={SectionFeaturesFallbackComponent}>
        <SectionFeatures sectionRef={featuresRef} />
      </Sentry.ErrorBoundary>

      <QuoteSection
        href="...."
        title="People form stereotypes based solely on a person’s musical preferences, and these stereotypes contain a kernel of truth"
        subtitle="The role of music preferences in interpersonal perception"
      />
      <SectionFeedback sectionRef={feedbackRef} />
      <QuoteSection
        href="...."
        title="When people listen to their favorite songs, brain regions responsible for communication and consolidation become activated"
        subtitle="Network science and the effects of music preference on functional Brain connectivity: From Beethoven to Eminem"
      />
      <SectionContact sectionRef={appRef} />
      <SectionFooter />
    </>
  );
};

export default Home;
